var header = document.querySelector('.header');
var search_toggle = document.querySelector('.header__search-toggle');
var search_box = document.querySelector('.header__search');
var lastScrollY = window.scrollY;

document.addEventListener('scroll', function () {
    var currentScrollY = window.scrollY;
    header.classList.toggle('header--scroll', currentScrollY >= 100);
    header.classList.toggle('header--scroll', currentScrollY > lastScrollY);
    lastScrollY = currentScrollY;
});

search_toggle.addEventListener('click', () => {
    search_box.classList.toggle('active');
    nav.classList.remove('nav--active');
    menu_trigger.classList.remove('nav__toggle--active')
    menu_trigger.setAttribute('aria-expanded', 'false')
})

$("#search-box").autocomplete({
    serviceUrl: "/umbraco/api/courseautocomplete/search",
    minChars: 2,
    onSelect: function (value) {
        // Redirect
        if (value) {
            window.location.href = value.data;
        }
    }
});